import { interactiveServiceFetch } from '../services/interactiveServiceFetch';
import { USER_MCP_CONNECTIONS_PATHS } from './constants';

export class UserMcpConnectionsApiError extends Error {
    constructor(status) {
        super(`MCP connections API error ${status}`);
        this.name = 'UserMcpConnectionsApiError';
        this.status = status;
    }
}

const request = async (url, options) => {
    const response = await interactiveServiceFetch(url, options);
    if (!response.ok) throw new UserMcpConnectionsApiError(response.status);
    if (response.status === 204) return null;
    return response.json();
};

const withAdminMode = (path, adminMode) => `${path}?${new URLSearchParams({ admin_mode: Boolean(adminMode) })}`;

export const fetchUserMcpConnections = adminMode => request(withAdminMode(USER_MCP_CONNECTIONS_PATHS.LIST, adminMode));

export const startUserMcpConnect = (provider, adminMode) =>
    request(withAdminMode(USER_MCP_CONNECTIONS_PATHS.start(provider), adminMode), { method: 'POST' });

export const disconnectUserMcpConnection = provider =>
    request(USER_MCP_CONNECTIONS_PATHS.connection(provider), { method: 'DELETE' });
